import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { testCaseService } from '@/services/testcase-service';
import { CampaignCheckStatuses } from '@/models/campaign/campaign-check-statuses';
import { appSettingsModule } from '@/store/app-settings-module';
import { DeliveryServer } from '@/models/delivery-server/delivery-server';
import { TrackingDomain } from '@/models/tracking-domain/tracking-domain';
import { deliveryServerService } from '@/services/delivery-server.service';
import { trackingDomainsService } from '@/services/tracking-domains.service';
import CreateDraftCampaignComponent from './components/create-draft-campaign/create-draft-campaign';
import { List } from '@/models/list/list';
import { listService } from '@/services/list.service';
import { TestCaseResponse } from '@/models/test-case/test-case-response';
import { CampaignResponse } from '@/models/campaign/campaign-response';
import { campaignService } from '@/services/campaign-service';

@Component({
    components: {
        'create-draft-campaign': CreateDraftCampaignComponent
    }
})
export default class ViewTestcaseComponent extends Vue {

    readonly campaignCheckedStatus = CampaignCheckStatuses.Checked
    readonly campaignQueuedStatus = CampaignCheckStatuses.Queued
    readonly campaignSentStatus = CampaignCheckStatuses.Sent
    readonly campaignErroredStatus = CampaignCheckStatuses.Errored

    @Prop() id: number

    @Ref() createDraftCampaign : CreateDraftCampaignComponent

    deliveryServers: DeliveryServer[] = []
    trackingDomains: TrackingDomain[] = []
    lists: List[] = []
    
    testCase: TestCaseResponse = null
    loading = true
    sortBy: string = 'primary'

    get campaigns() {
        return (this.testCase ? this.testCase.campaigns : []).sort((c1, c2) => {
            return c2[this.sortBy] - c1[this.sortBy]
        })
    }

    get labels() {
        return [
            { name: 'primary', variant: 'success', text: 'Primary Inbox' },
            { name: 'inbox', variant: 'success', text: 'Inbox' },
            { name: 'promotions', variant: 'primary', text: 'Promotions' },
            { name: 'updates', variant: 'warning', text: 'Updates' },
            { name: 'spam', variant: 'danger', text: 'Spam' }
        ]
    }

    get sortByVariant() {
        return this.labels.find(x => x.name == this.sortBy).variant
    }

    get sortByText() {
        return this.labels.find(x => x.name == this.sortBy).text
    }

    @Watch('id', { immediate: true })
    async idChanged(id: number) {
        this.loading = true
        try {
            this.testCase = await testCaseService.getById(id)
            if (this.testCase.mailWizzInstanceId != appSettingsModule.activeMailWizzId) {
                appSettingsModule.setActiveMailWizzId(this.testCase.mailWizzInstanceId)
                if (!appSettingsModule.activeMailWizz) {
                    await appSettingsModule.fetchMailWizzInstances()
                }
            }
            [ this.deliveryServers, this.trackingDomains, this.lists ] = await Promise.all([
                <any>deliveryServerService.getAll<DeliveryServer>(),
                trackingDomainsService.getAll<TrackingDomain>(),
                listService.getAll<List>()
            ])
        }
        finally {
            this.loading = false
        }
    }

    getCampaignLink(campaign: CampaignResponse) {
        return campaignService.generateCampaignLink(campaign.campaignMailWizzId)
    }

    getDeliveryServerDescription(id) {
        const ds = this.deliveryServers.find(x => x.mailWizzEntityId == id)
        return ds ? ds.name : ''
    }

    getTrackingDomainDescription(id) {
        const td = this.trackingDomains.find(x => x.mailWizzEntityId == id)
        return td ? td.name : ''
    }

    createDraft(campaign: CampaignResponse) {
        this.createDraftCampaign.show(campaign)
    }

    setSortBy(field: string) {
        this.sortBy = field
    }

    back() {
        this.$router.push('/testcases')
    }
}
